import React from 'react';
import { connect } from 'react-redux';
import { State } from 'store/state';
import { isHostedFieldsSuccessUploadModalOpenSelector } from 'store/state/app/selectors';
import { IconWrapper, TextArea, Title, Wrapper } from './styled';
import { setHostedFieldsSuccessUploadModalAction } from 'store/state/app/actions';
import { useLocale } from 'locale';
import OkIcon from 'assets/svg/success-ic-v2.svg';
import { ModalWrapper } from './Wrapper';
import { SocialLinks } from './SocialLinks';


const SuccessModalBase: React.FC<{
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
}> = ({ isOpen, setOpen }) => {
  const { t } = useLocale();

  return (
    <ModalWrapper isOpen={isOpen} onClose={() => setOpen(false)}>
      <Wrapper>
        <IconWrapper>
          <OkIcon />
        </IconWrapper>
        <Title>{t('payment.successUpload.modal.title')}</Title>
        <TextArea>{t('payment.successUpload.modal.text')}</TextArea>
        <SocialLinks />
      </Wrapper>
    </ModalWrapper>
  );
};

const mapStateToProps = (state: State) => ({
  isOpen: isHostedFieldsSuccessUploadModalOpenSelector(state),
});

const mapDispatchToProps = {
  setOpen: setHostedFieldsSuccessUploadModalAction,
};

export const PaymentSuccessUploadModal = connect(mapStateToProps, mapDispatchToProps)(SuccessModalBase);
